var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import DatePickerCalendar from './DatePickerCalendar';
import useDatePicker from './useDatePicker';
import DatePickerTextField from './DatePickerTextField';
/**
 * Kareo component that utilizes Calendar and TextField
 * We attempted to keep the API compatible with Mui DatePicker - https://mui.com/api/date-picker/
 *
 * @storybook: [Date  Picker](http://design.kareo.com/master/?path=/story/components-inputs-datepicker--date-picker-main)
 */
var DatePicker = function (_a) {
    var onChange = _a.onChange, onError = _a.onError, onMonthChange = _a.onMonthChange, renderInput = _a.renderInput, value = _a.value, error = _a.error, props = __rest(_a, ["onChange", "onError", "onMonthChange", "renderInput", "value", "error"]);
    var _b = useDatePicker(__assign(__assign({}, props), { value: value,
        error: error,
        onChange: onChange,
        onError: onError,
        onMonthChange: onMonthChange })), date = _b.date, month = _b.month, input = _b.input, calendar = _b.calendar;
    var defaultInput = useCallback(function (params) {
        return React.createElement(DatePickerTextField, __assign({}, params));
    }, []);
    var RenderedInput = renderInput || defaultInput;
    var onChangeRenderedInput = React.useCallback(function (event) {
        var _a;
        if (input.onChange)
            input.onChange((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value);
    }, [input.onChange]);
    var onBlurRenderedInput = React.useCallback(function () {
        if (input.onBlur)
            input.onBlur();
        return input.value;
    }, [input.onBlur]);
    var onClickRenderedInputIcon = React.useCallback(function (event) {
        event.preventDefault();
        event.stopPropagation();
        calendar.toggle();
    }, [calendar.toggle]);
    var renderedInputError = error || input.error;
    return (React.createElement("div", { className: "date-picker-container" },
        React.createElement(RenderedInput, { inputRef: calendar.anchorElRef, error: renderedInputError, value: input.value, label: input.label, onBlur: onBlurRenderedInput, onChange: onChangeRenderedInput, onIconClick: onClickRenderedInputIcon }),
        React.createElement(DatePickerCalendar, { anchorEl: calendar.getAnchorElm(), open: calendar.open, date: date.date, monthDate: month.date, onChange: function (dateValue) { return calendar.onChange(dateValue); }, onClose: function () { return calendar.toggle(false); }, onMonthChange: calendar.onMonthChange })));
};
DatePicker.defaultProps = {};
DatePicker.displayName = 'KareoDatePicker';
export default DatePicker;
